import {useParams, useSearchParams} from 'react-router-dom';

import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {PersonnelForm} from 'src/app/personnel/PersonnelForm/PersonnelForm';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {VendorManagePersonnelRouteService} from 'src/shared/services/RouterService/VendorManagePersonnelRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const VendorPersonnelEditPage = () => {
  useSetDocumentTitle(PersonnelDocumentTitle);
  const {personnelId, vendorId, view} = useParams();
  const [searchParams] = useSearchParams();

  const fromTabParam = searchParams.get('from');
  const fromTab = fromTabParam === 'all' ? 'all'
    : fromTabParam === 'activity' ? 'activity'
    : 'vendor' as const;

  const mode: ViewModeType = 'edit';
  const router = new VendorManagePersonnelRouteService(false, mode, {
    view: view as PersonnelViewType,
    vendorId: String(vendorId),
    fromTab,
  });

  return (
    <PersonnelForm
      mode={mode}
      userType={UserTypeEnum.Contractor}
      vendorId={+vendorId!}
      id={+personnelId!}
      view={view as PersonnelViewType}
      enableEdit={true}
      router={router}
    />
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.VendorPersonnelEdit(':personnelId', ':vendorId', ':view'),
  element: <VendorPersonnelEditPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});

export default VendorPersonnelEditPage;
